module.exports = __webpack_public_path__ + "static/media/copy-icon-white.97eacbe9.svg";